import Raven from 'raven-js/dist/raven';



export const initSentry = () => {
  if (__SENTRY_DSN__) {
    Raven.config(__SENTRY_DSN__, {
      debug: true,
      logger: 'javascript',
      release: __APP_STAMP__,
      allowSecretKey: true
    }).install();
  }
};



// WEBPACK FOOTER //
// ./src/lib/sentry.js